// MArket.js
import React, { useState } from "react";
import LanguageModal from "./LanguageModal";

const Market = () => {
  const [showModal, setShowModal] = useState(false);

  const links = {
    de: "https://drive.google.com/file/d/1tWBAykTYUFrJPVBgHS1HkkR09daXOhox/view?usp=drive_link",
    en: "https://drive.google.com/file/d/1K4NqltVmBLG3IteB22E_6SWk3SPoes5G/view?usp=drive_link",
    es: "https://drive.google.com/file/d/1d72W6Iv0U_ozK8TgpYvrMTLwsTaRhj-f/view?usp=drive_link",
    fr: "https://drive.google.com/file/d/1bENHfWc9HaVfuDnDEYcyUsTSpz6ha8JY/view?usp=drive_link",
  };

  return (
    <>
      <button className="full-width-button" onClick={() => setShowModal(true)}>
        <i className="bi bi-shop icon-space" />
        Mercados Mallorca
      </button>
      {showModal && (
        <LanguageModal
          title="Mercados Mallorca"
          icon="bi bi-shop"
          links={links}
          onClose={() => setShowModal(false)}
        />
      )}
    </>
  );
};

export default Market;
